import { useState, useEffect } from "react"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils/cn"

const navItems = [
  { id: "loop", label: "学习闭环" },
  { id: "xiaozhi", label: "小智" },
  { id: "features", label: "功能" },
  { id: "platforms", label: "下载" },
]

export function Header() {
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20)
    }
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const scrollToSection = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <header
      className={cn(
        "fixed top-0 left-0 right-0 z-50 transition-colors duration-200",
        isScrolled
          ? "bg-canvas/90 backdrop-blur-md border-b border-hairline"
          : "bg-transparent"
      )}
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <img
            src="/landing/logo.jpeg"
            alt="智因错题本"
            className="w-8 h-8 rounded-md object-cover"
          />
          <span className="text-label text-ink">智因错题本</span>
        </div>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollToSection(item.id)}
              className="text-label text-ink-soft hover:text-ink transition-colors"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <Button size="sm" onClick={() => scrollToSection("platforms")}>
          免费开始
        </Button>
      </div>
    </header>
  )
}
